/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiComponentTypeFromJSON, ApiComponentTypeToJSON, } from './ApiComponentType';
export function InlineObject7FromJSON(json) {
    return InlineObject7FromJSONTyped(json, false);
}
export function InlineObject7FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adId': !exists(json, 'adId') ? undefined : json['adId'],
        'advanced': !exists(json, 'advanced') ? undefined : json['advanced'],
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'type': !exists(json, 'type') ? undefined : ApiComponentTypeFromJSON(json['type']),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function InlineObject7ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adId': value.adId,
        'advanced': value.advanced,
        'componentId': value.componentId,
        'name': value.name,
        'prompt': value.prompt,
        'type': ApiComponentTypeToJSON(value.type),
        'url': value.url,
    };
}
